import { TranslationRO } from '@routellers/types/dist/translation/translation.ro';
import { UpdateTranslationLocaleDto } from '@routellers/types/dist/translation/update-translation-locale.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    id: number;
    data: UpdateTranslationLocaleDto;
};

type ResponseData = TranslationRO;

export const updateLocale: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, data }) => ({
    url: `/translations/locales/${id}`,
    method: 'PATCH',
    data,
});
